import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import EventsOverlay from "../page/events/EventsOverlay";
import CreditsOverlay from "../page/credits/CreditsOverlay";
import TestCreditsOverlay from "../page/credits/TestCreditsOverlay";

class OverlayRouter extends React.Component {

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route index element={<EventsOverlay/>} />
                    <Route path="events">
                        <Route index element={<EventsOverlay/>} />
                    </Route>
                    <Route path="credits">
                        <Route index element={<CreditsOverlay/>} />
                        <Route path="test" element={<TestCreditsOverlay/>} />
                    </Route>
                </Routes>
            </BrowserRouter>
        );
    }
}

export default OverlayRouter;